require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./clackamas-county-transition-center.json") })
        }
      }, "path---clackamas-county-transition-center");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---clackamas-county-transition-center!./.cache/json/clackamas-county-transition-center.json
// module id = 854
// module chunks = 231608221292675